<template>
  <div class="home">
      <div class="grey-bg"></div>
    <HelloWorld/>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from "@/components/HelloWorld.vue";

export default {
  name: "home",
  components: {
    HelloWorld
  }
};
</script>
<style scoped lang="less">
.home {
  max-width: 600px;
  margin: 0 auto;
}

.grey-bg {
  position: fixed;
  width: 100%;
  height: 250px;
  z-index: 2;
  background: linear-gradient( to bottom, #f2f3f6 0%, #fff 100%);
}

</style>